// Hooks
import Text from 'ui3/Text/Text';
// Components
import SocialMediaForm from './SocialMediaForm/SocialMediaForm';
// Styles
import styles from './SocialMediaStep.module.scss';

type SocialMediaStepProps = {
  isNewSocialMediaIntegration?: boolean;
};

const SocialMediaStep = ({
  isNewSocialMediaIntegration,
}: SocialMediaStepProps) => {
  return (
    <div className={styles.container}>
      <div>
        <Text className={styles.text} variant="h2">
          Link Your Social Accounts
        </Text>

        <Text
          className={styles.text}
          variant="body1Regular16"
          color="lights-medium"
        >
          Add your social accounts for verification and so that brands and fans
          can find you.
        </Text>
      </div>
      <SocialMediaForm
        isNewSocialMediaIntegration={isNewSocialMediaIntegration}
      />
    </div>
  );
};

export default SocialMediaStep;
